const mobileDeviceWidth = 768

const isMobile = () => window.innerWidth <= mobileDeviceWidth

export default isMobile
